import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "@/api/client";
import { LifeBuoy, Filter, ChevronRight } from "lucide-react";
import Avatar from "@/components/Avatar";

const STATUS = { open: { label: "Açık", cls: "ky-badge-warning" }, pending: { label: "Bekliyor", cls: "ky-badge-info" }, closed: { label: "Kapalı", cls: "ky-badge-neutral" } };
const PRIORITY = { dusuk: "Düşük", orta: "Orta", yuksek: "Yüksek" };

export default function TicketsPage() {
  const [items, setItems] = useState([]); const [status, setStatus] = useState("open");
  const nav = useNavigate();
  useEffect(() => { apiClient.get(`/tickets${status ? `?status=${status}` : ""}`).then(r => setItems(r.data)); }, [status]);

  return (
    <div className="space-y-5" data-testid="tickets-page">
      <div><h1 className="text-2xl font-bold">Destek Talepleri</h1><p className="text-sm text-[#64748B] mt-1">{items.length} talep</p></div>

      <div className="ky-card p-3 flex items-center gap-2 flex-wrap">
        <Filter size={12} className="text-[#94A3B8]"/>
        {["open", "pending", "closed", ""].map(s => (
          <button key={s||"all"} onClick={() => setStatus(s)} className={`ky-tab ${status === s ? "ky-tab-active" : ""}`} data-testid={`ticket-filter-${s||"all"}`}>{s ? STATUS[s].label : "Tümü"}</button>
        ))}
      </div>

      <div className="ky-card overflow-hidden">
        {items.length === 0 && <div className="text-center py-16 text-[#94A3B8] flex flex-col items-center gap-2"><LifeBuoy size={32}/>Destek talebi yok.</div>}
        {items.map(t => (
          <button key={t.id} onClick={() => nav(`/destek/${t.id}`)} className="w-full flex items-center gap-4 px-5 py-4 border-b border-[#ECECEF] hover:bg-[#FAFAFB] text-left transition" data-testid={`ticket-${t.id}`}>
            <Avatar name={t.customer_name} size={36}/>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className={`ky-badge ${STATUS[t.status]?.cls}`}>{STATUS[t.status]?.label}</span>
                <span className="ky-badge ky-badge-neutral">{PRIORITY[t.priority] || t.priority}</span>
                <span className="text-sm font-medium truncate">{t.subject}</span>
              </div>
              <div className="text-xs text-[#64748B] mt-1">{t.customer_name} · {new Date(t.updated_at).toLocaleString("tr-TR")}</div>
            </div>
            <ChevronRight size={16} className="text-[#94A3B8]"/>
          </button>
        ))}
      </div>
    </div>
  );
}
